<template>
    <div>
        <b-table striped ref="cardsGrid" :items="filteredItems" :fields="fields" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :busy="isLoading" show-empty empty-text="No cards for this patient."
            :tbody-tr-class="colorCodeTable">
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle" />
                    <strong>Loading...</strong>
                </div>
            </template>
            <template #cell(brand)="data">
                <div class="d-flex align-items-center" style="gap: 6px;">
                    <i v-if="data.value === 'Visa'" class="fab fa-cc-visa fa-2x fa-fw"></i>
                    <i v-else-if="data.value === 'MasterCard'" class="fab fa-cc-mastercard fa-2x fa-fw"></i>
                    <i v-else-if="data.value === 'Discover'" class="fab fa-cc-discover fa-2x fa-fw"></i>
                    <i v-else-if="data.value === 'American Express'" class="fab fa-cc-amex fa-2x fa-fw"></i>
                    {{ data.value }}
                </div>
            </template>
            <template #cell(actions)="data">
                <input type="radio" v-model="selectedCardId_" :value="data.item.id" v-if="!disabled">
            </template>
            <template #cell(expiration)="data">
                {{ data.item.expMonth | numeral('00') }}/{{ data.item.expYear }}
            </template>
        </b-table>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import { Component, Watch, Prop } from 'vue-property-decorator';

import { StripeCard } from '@/models/Payment';
import { NotificationOptions } from '@/util/NotificationOptionsPresets';

@Component({
    name: "CardsTable",
    components: {
    },
})
export default class CardsTable extends Vue {
    /**
     * @value is the StripeCustomerID
     */
    @Prop() private value!: number
    @Prop() private selectedCardID!: string;
    @Prop() private disabled!: boolean;
    @Prop() private pendingDelete!: boolean;

    private isLoading = false;
    private items: Array<StripeCard> = [];
    private fields: any[] = [
        { key: "actions", label: '' },
        { key: "brand", label: 'Brand' },
        { key: "cardNumber", label: "Card Ends With" },
        { key: "expiration", label: "Expiration" },
    ];
    private sortBy = 'cardNumber';
    private sortDesc = false;
    private selectedCardId_ = '';

    created() {
        this.updatedSelectedCardIdProp();
    }

    @Watch("selectedCardID") updatedSelectedCardIdProp() {
        if (this.selectedCardID) this.selectedCardId_ = this.selectedCardID;
    }

    @Watch('value') stripeIDChanged() {
        this.loadPatientPaymentMethods();
    }

    loadPatientPaymentMethods() {
        if (!this.value) return;

        this.isLoading = true;
        this.$http.get<Array<StripeCard>>(`/stripe/cards/${this.value}`)
            .then(response => {
                if (response?.data?.length) {
                    this.items = response.data;
                    this.items.sort((a, b) => {
                        return Number(a.cardNumber) - Number(b.cardNumber);
                    })
                }
            })
            .catch(error => {
                console.error("Error while getting Payment Cards from Patient", { error, response: error?.response });
                this.$notification(NotificationOptions.error(error));
            })
            .finally(() => {
                this.isLoading = false;
            });
    }

    @Watch('selectedCardId_')
    cardSelected(cardId: string) {
        if (!cardId) return;

        this.$emit('cardSelected', cardId);
    }

    colorCodeTable(row: StripeCard, type: any) {
        if (!row || type !== 'row')
            return;
        if (row.id == this.selectedCardId_)
            return 'table-success font-weight-bolder';
    }

    get filteredItems() {
        let items = this.items;

        if (!this.pendingDelete) {
            items = items.filter(i => !i.pendingDelete);
        }

        return items;
    }
}
</script>